import { render } from "./ClearYourBill.vue?vue&type=template&id=1312ea52&scoped=true"
import script from "./ClearYourBill.vue?vue&type=script&lang=js"
export * from "./ClearYourBill.vue?vue&type=script&lang=js"

import "./ClearYourBill.vue?vue&type=style&index=0&id=1312ea52&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1312ea52"]])

export default __exports__